import { CSSProperties } from 'react';

const containerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  backgroundColor: 'var(--background-base)',
  fontFamily: 'var(--encore-body-font-stack)',
  padding: 'var(--encore-spacing-looser)',
};

const cardStyle: CSSProperties = {
  maxWidth: 520,
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--encore-spacing-base)',
  padding: 'var(--encore-spacing-looser)',
  backgroundColor: 'var(--background-elevated-base)',
  borderRadius: 'var(--encore-corner-radius-larger)',
  border: '1px solid var(--essential-negative)',
};

const titleStyle: CSSProperties = {
  fontSize: 'var(--encore-text-size-large)',
  fontWeight: '700',
  color: 'var(--text-base)',
  margin: 0,
};

const messageStyle: CSSProperties = {
  fontSize: 'var(--encore-text-size-smaller)',
  color: 'var(--text-subdued)',
  lineHeight: 1.5,
  margin: 0,
};

const linkStyle: CSSProperties = {
  color: 'var(--text-base)',
  fontWeight: '700',
};

const buttonStyle: CSSProperties = {
  padding: 'var(--encore-spacing-tighter-2) var(--encore-spacing-looser)',
  fontSize: 'var(--encore-text-size-smaller)',
  fontWeight: '700',
  fontFamily: 'var(--encore-body-font-stack)',
  color: '#000', // TODO(encore): use .encore-bright-accent-set class + var(--text-base)
  backgroundColor: 'var(--essential-bright-accent)',
  border: 'none',
  borderRadius: '9999px',
  cursor: 'pointer',
};

export const AppCrashFallback = () => (
  <div style={containerStyle}>
    <div style={cardStyle}>
      <h1 style={titleStyle}>Oops, something went wrong…</h1>
      <p style={messageStyle}>
        Sorry, looks like we encountered an error. Try refreshing the page, or
        contact our{' '}
        <a href="mailto:experimentation-cs@spotify.com" style={linkStyle}>
          Customer Support team
        </a>{' '}
        for help.
      </p>
      <div>
        <button onClick={() => window.location.reload()} style={buttonStyle}>
          Reload page
        </button>
      </div>
    </div>
  </div>
);
